import { show, hide, addQueryParamUrl, } from '../lib/jsfunc.js'
import { on, ready, query, queryAll } from '../lib/dom.js'
import * as grid from './Grid/Grid.js'

on('change', '.grid-kategorie', function(event) {
  var select = event.target;
  window.location = select.options[select.selectedIndex].getAttribute('data-url');
});

ready(function(){
  var shop = query('.SHOP');
  if(shop){
    on('mouseleave', 'div.content', onMouseLeaveContent)
    on('mouseleave', '.GridTable', onMouseLeaveBody)

    var eigenschaften = query('.GridOptions');
    var table = query('.GridTable');
    if (!table) {
      return;
    }

    // Initial
    setTimeout(query('.GridTable tr.value th.name input').focus(),0); 

    var firstTR = query(table, 'tbody tr:first-child');
    if(firstTR){
      showPreview(firstTR);
    }
    
    [].forEach.call( queryAll(eigenschaften, '.headtype img'), function(elem) {
      elem.addEventListener('click', grid.selectDistincts);
    });
    
    [].forEach.call( queryAll(eigenschaften, '.drivetype img'), function(elem) {
      elem.addEventListener('click', grid.selectDistincts);
    });
    
    [].forEach.call( queryAll(eigenschaften, '.images select'), function(elem) {
      elem.addEventListener('change', grid.selectSelect);
    });
    
    var sel = query(eigenschaften, 'select.din');
    if(sel){
      sel.addEventListener('change', grid.select);
    }
    
    var sel = query(eigenschaften, 'select.material');
    if(sel){
      sel.addEventListener('change', grid.select);
    }
    
    var sel = query(eigenschaften, 'select.d1');
    if(sel){
      sel.addEventListener('change', grid.select);
    }
    
    var sel = query(eigenschaften, 'select.L');
    if(sel){
      sel.addEventListener('change', grid.select);
    }
    
    [].forEach.call( queryAll(eigenschaften, '.operator select'), function(elem) {
      elem.addEventListener('change', grid.selectOperator);
    });
    
    [].forEach.call( queryAll(eigenschaften, '.value input'), function(elem) {
      elem.addEventListener('change', grid.updateInput);
    });
    
    [].forEach.call( queryAll(eigenschaften, 'img.image.active'), function(elem) {
      elem.addEventListener('mouseenter', imageOnMouseEnter);
    });
    
    [].forEach.call( queryAll(eigenschaften, 'img.image-selected'), function(elem) {
      elem.addEventListener('mouseout', imageOnMouseOut);
    });
    
    [].forEach.call( queryAll(eigenschaften, '.reset, .icons-reset-blue'), function(elem) {
      elem.addEventListener('click', grid.resetGridEigenschaften);
    });
    
    // global mouseover
    document.body.addEventListener('mouseover', function(event) {
      [].forEach.call( queryAll('.GridTable tbody tr td'), function(elem) {
        if(elem == event.target){
          onMouseEnterRow(event);
        }
      });
    });
    
    var table = query('.GridTable');
    // global click
    document.body.addEventListener('click', function(event) {
      [].forEach.call( queryAll(table, 'tbody tr td'), function(elem) {
        if(elem == event.target){
          onClickRow(event);
        }
      });
      
      [].forEach.call( queryAll(table, '.label :not(.reset)'), function(elem) {
        if(elem == event.target){
          grid.updateOrderBy(event);
        }
      });
      
      [].forEach.call( queryAll(table, '.label th:last-child,.reset'), function(elem) {
        if(elem == event.target){
          grid.resetGrid(event);
        }
      });
      
      [].forEach.call( queryAll(table, '.limit .next, .limit .prev'), function(elem) {
        if(elem == event.target){
          grid.updateLimit(event);
        }
      });
    });
    
    // global change
    document.body.addEventListener('change', function(event) {
      [].forEach.call( queryAll(table, '.operator select, .value select, .value input'), function(elem) {
        if(elem == event.target){
          addQueryParamUrl(elem.getAttribute('name'), elem.value.trim());
          grid.updateData(event);
        }
      });
      
      [].forEach.call( queryAll(table, '.value select, .operator select'), function(elem) {
        if(elem == event.target){
          grid.updateEigenschaften(event);
        }
      });
    });
    
    // global keyup: Enter für input Felder
    document.body.addEventListener('keyup', function(event) {
      [].forEach.call( queryAll('.GridOptions input,.GridResults input'), function(elem) {
        if(elem == event.target){
          addQueryParamUrl(elem.getAttribute('name'), elem.value.trim());
          grid.updateData(event);
        }
      });
    });
    
    var input = document.getElementById('suchbegriff');
    if(input){
      input.addEventListener('change', suchbegriff);
    }
  }
})

function showPreview(tr){
  var previewTd = query(tr, 'td.preview');
  var previewPanel = query('.panel-preview');
  var contactPanel = query('.panel-contact');

  if(previewPanel){
    if (previewTd) {
      previewPanel.innerHTML = previewTd.innerHTML;
      show(previewPanel);

      if(contactPanel){
        hide(contactPanel);
      }
    } else {
      hide(previewPanel);
      if(contactPanel){
        show(contactPanel);
      }
    }
  }
}

function showContact(){
  var previewPanel = query('.panel-preview');
  var contactPanel = query('.panel-contact');

  if (previewPanel){
    hide(previewPanel);
    if(contactPanel){
      show(contactPanel);
    }
  }
}

function onClickRow(event) {
  event = event ? event : window.event;
  var tr =  event.target.tagName == 'TR' ? event.target : event.target.closest('tr');

  if( event.target.tagName == 'TD' && event.target.matches('.name')){
    var url = tr.getAttribute('data-url');
    window.location = url;
  }

  var tbody = tr.closest('tbody');
  var trSel = query(tbody, 'tr.selected');

  var previewTd, previewDiv;

  if (tr.matches('.selected')) {
    tr.classList.remove('selected');
  } else {
    if(trSel){
      trSel.classList.remove('selected');
    }
    tr.classList.add('selected');

    showPreview(tr);
  }
}

function onMouseEnterRow(event) {
  event = event ? event : window.event;

  var tr =  event.target.tagName == 'TR' ? event.target : event.target.closest('tr');

  var tbody = tr.closest('tbody');
  var trSel = query(tbody, 'tr.selected');

  if(trSel) {
    return;
  }

  showPreview(tr);
}

function onMouseLeaveContent(event) {
  event = event ? event : window.event;
  if(document.getElementById('page-shop-gridindex')){
    var trSel = query('tr.selected');
    if(trSel){
      trSel.classList.remove('selected');
    }
    showContact();
  }else{
    return false;
  }
}

function onMouseLeaveBody(event) {
  event = event ? event : window.event;

  var tr = event.target;
  var previewDiv;
  var tbody = tr.closest('tbody');

  if(tbody){
    var trSel = query(tbody, 'tr.selected');
    if (trSel) {
      return;
    }
  }
  showContact();
}

function suchbegriff(event){
  event = event ? event : window.event;

  var value = event.target.value.trim();
  addQueryParamUrl('pattern', value);
  grid.updateData(event);
}

function imageOnMouseEnter(event) {
  event = event ? event : window.event;

  var isSelected = event.target.matches('.image-selected.active');

  if(!isSelected){
    var a = event.target.closest('a');
    show(query(a, '.image-selected'));
    hide(query(a, '.image'));
  }
}

function imageOnMouseOut(event) {
  event = event ? event : window.event;

  var isSelected = event.target.matches('.image-selected.active');

  if(!isSelected){
    var a = event.target.closest('a');
    hide(query(a, '.image-selected'));
    show(query(a, '.image'));
  }
}